import { useEffect, useState } from "react";
import { useUpdateAssignmentMarkMutation } from "../../../features/assignmentMark/assignmentMarkApi";
import { dateSaperator } from "../../../utils/commonUtility";

export default function AssignmentMarkItem({ assignmentMark, markSendResultHandler }) {
	const {
		id,
		title,
		createdAt,
		student_name,
		status,
		mark,
		totalMark,
		repo_link,
	} = assignmentMark || {};
	const dateFormatted = Object.values(dateSaperator(createdAt)).join(" ");
	
	const [updateAssignmentMark, { isError: isMarkSentError, isSuccess: isMarkSentSuccess }] =
	useUpdateAssignmentMarkMutation() || [];
	
	const [givenMark, setGivenMark] = useState(totalMark);
	
	const handleSendAssignmentMark = () => {
		updateAssignmentMark({
			id: id,
			mark: Number(givenMark),
		});
	};

	useEffect(() => {
		if (isMarkSentSuccess) {
			markSendResultHandler("sent-success");
		} else if (isMarkSentError) {
			markSendResultHandler("sent-fail");
		}
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isMarkSentError, isMarkSentSuccess]);

	const restrictAndSetGivenMark = (value) => {
		const givenMarkInt = Number(value);
		if (givenMarkInt < 0) {
			setGivenMark(0);
		} else if (givenMarkInt > totalMark) {
			setGivenMark(totalMark);
		} else {
			setGivenMark(value);
		}
	};

	return (
		<tr>
			<td className="table-td">{title}</td>
			<td className="table-td">{dateFormatted}</td>
			<td className="table-td">{student_name}</td>
			<td className="table-td">{repo_link}</td>

			{status === "pending" ? (
				<td className="table-td input-mark">
					<input
						value={givenMark}
						onChange={(e) =>
							restrictAndSetGivenMark(e.target.value)
						}
						type="number"
					/>
					<svg
						onClick={handleSendAssignmentMark}
						fill="none"
						viewBox="0 0 24 24"
						strokeWidth="2"
						stroke="currentColor"
						className="w-6 h-6 text-green-500 cursor-pointer hover:text-green-400"
					>
						<path
							strokeLinecap="round"
							strokeLinejoin="round"
							d="M4.5 12.75l6 6 9-13.5"
						/>
					</svg>
				</td>
			) : (
				<td className="table-td">{mark}</td>
			)}
		</tr>
	);
}
